module.exports = __webpack_public_path__ + "img/discord-blue.8be7c6d6.svg";